// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_2f-1l","badgeButtonWrapper":"_2f-1l","badge-button":"JXO2K","badgeButton":"JXO2K","badge":"B7B88"};